__turbopack_context__.v({
  "arrow": "Zp52Ha_arrow",
  "arrowNext": "Zp52Ha_arrowNext",
  "arrowPrev": "Zp52Ha_arrowPrev",
  "dot": "Zp52Ha_dot",
  "dotActive": "Zp52Ha_dotActive",
  "dotFill": "Zp52Ha_dotFill",
  "dots": "Zp52Ha_dots",
  "edge": "Zp52Ha_edge",
  "edgeL": "Zp52Ha_edgeL",
  "edgeR": "Zp52Ha_edgeR",
  "isOff": "Zp52Ha_isOff",
  "moreNav": "Zp52Ha_moreNav",
  "noScroll": "Zp52Ha_noScroll",
  "track": "Zp52Ha_track",
  "visitStore": "Zp52Ha_visitStore",
  "wrap": "Zp52Ha_wrap",
});
